import { jwtDecode } from "jwt-decode";

export type DecodedToken = {
  sub: string;
  exp?: number;
  [key: string]: any;
};

export class JwtService {
  decodeToken(token: string): DecodedToken {
    try {
      return jwtDecode<DecodedToken>(token);
    } catch {
      return {} as DecodedToken;
    }
  }

  isTokenExpired(token: string): boolean {
    try {
      const decoded = jwtDecode<DecodedToken>(token);
      if (!decoded.exp) return false;
      const now = Date.now() / 1000;
      return decoded.exp < now;
    } catch {
      return true;
    }
  }

  getTokenExpirationDate(token: string): Date | null {
    try {
      const decoded = jwtDecode<DecodedToken>(token);
      if (!decoded.exp) return null;
      return new Date(decoded.exp * 1000);
    } catch {
      return null;
    }
  }
}

export const jwtService = new JwtService();
